// extracted by mini-css-extract-plugin
module.exports = {"roulette":"styles_roulette__M_3zC"};